import { ChainType } from '@lifi/types';
export function isSolana(provider) {
    return provider.type === ChainType.SVM;
}
export const TokenProgramId = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA';
export const Token2022ProgramId = 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb';
//# sourceMappingURL=types.js.map